import { DeepPartial } from '@apollo/client/utilities'
import { AttendanceOvertimeRequestApprovableMetadataFragment } from 'generated/resources/graphql'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import { durationToText } from 'modules/core/lib/duration'

export const getAttendanceOvertimeRequestMetadata = (
  data: DeepPartial<AttendanceOvertimeRequestApprovableMetadataFragment>
) => {
  const date = data.date ? stringToDate(data.date, 'backend_datetime') : undefined

  const minutes =
    data.hoursAmountInCents !== undefined ? (data.hoursAmountInCents / 100) * 60 : undefined

  const displayDate = date ? i18nDateToString(date, 'ui_dmy_long') : ''

  const displayOvertime = minutes ? `+${durationToText(minutes, 'minutes')}` : undefined

  return [displayDate, displayOvertime].filter(Boolean)
}
